import { executeQueryJSON } from "@arcgis/core/rest/query.js";

export default function getParcelInfo(parcelQueryUrl, parcelPin) {
    return new Promise((resolve, reject) => {
        executeQueryJSON(parcelQueryUrl, {
            where: `PIN = '${parcelPin}'`,
            returnGeometry: true,
            outFields: ["*"]
        }).then((results) => {
            resolve(results);
        }).catch((error) => {
            reject(error);
        });
    });
}
